export const config = {
  termsUrl: "https://gosselingroup.eu/en/general-conditions-moving",
  slaUrl: "https://gosselingroup.eu/en/media/311/download",
};
